export const BASE_GROUP_LINKS = {
    LINK_CLIENT: '/',
    LINK_ACCOUNT: '/account',
    LINK_ADMIN: '/administrator',
    LINK_404: '/404'
};
